import React from 'react';

const DEFAULT_SECONDS = 600; // 5 minutes
const DEFAULT_STORAGE_KEY = 'otpResendNextAt';

export default class ResendOTPPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      secondsLeft: 0,
    };
    this.intervalId = null;
    this.handleClick = this.handleClick.bind(this);
    this.startTick = this.startTick.bind(this);
    this.stopTick = this.stopTick.bind(this);
    this.onStorage = this.onStorage.bind(this);
  }

  componentDidMount() {
    const storageKey = this.props.storageKey || DEFAULT_STORAGE_KEY;
    const now = Date.now();
    const nextAt = Number(localStorage.getItem(storageKey) || 0);

    if (nextAt > now) {
      const initial = Math.ceil((nextAt - now) / 1000);
      this.setState({ secondsLeft: initial }, () => {
        this.startTick(nextAt);
      });
    }

    window.addEventListener('storage', this.onStorage);
  }

  componentWillUnmount() {
    this.stopTick();
    window.removeEventListener('storage', this.onStorage);
  }

  onStorage(e) {
    const storageKey = this.props.storageKey || DEFAULT_STORAGE_KEY;
    if (e.key !== storageKey) return;

    const updatedNextAt = Number(e.newValue || 0);
    const now = Date.now();

    if (!updatedNextAt || updatedNextAt <= now) {
      this.setState({ secondsLeft: 0 });
      this.stopTick();
    } else {
      const secondsLeft = Math.ceil((updatedNextAt - now) / 1000);
      this.setState({ secondsLeft });
      this.startTick(updatedNextAt);
    }
  }

  startTick(nextAt) {
    this.stopTick(); // avoid duplicate intervals

    this.intervalId = setInterval(() => {
      const now = Date.now();
      if (now >= nextAt) {
        this.setState({ secondsLeft: 0 });
        this.stopTick();
      } else {
        const secondsLeft = Math.ceil((nextAt - now) / 1000);
        if (secondsLeft !== this.state.secondsLeft) {
          this.setState({ secondsLeft });
        }
      }
    }, 500); // update twice a second for smooth countdown
  }

  stopTick() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  format(total) {
    const m = Math.floor(total / 60);
    const s = total % 60;
    return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
  }

  startCooldown() {
    const seconds = this.props.cooldownSeconds || DEFAULT_SECONDS;
    const storageKey = this.props.storageKey || DEFAULT_STORAGE_KEY;

    const nextAt = Date.now() + seconds * 1000;
    localStorage.setItem(storageKey, String(nextAt));

    this.setState({ secondsLeft: seconds }, () => {
      this.startTick(nextAt);
    });
  }

  async handleClick() {
    const { secondsLeft } = this.state;
    if (secondsLeft > 0) return;

    try {
      const { onResend } = this.props;
      if (typeof onResend === 'function') {
        await onResend();
      }
      // Only start cooldown after successful resend
      this.startCooldown();
    } catch (e) {
      console.error('Failed to resend OTP:', e);
      // Optional: still start cooldown to prevent abuse
      // this.startCooldown();
    }
  }

  render() {
    const {
      className = '',
      style = {},
      labelReady = 'Renvoyer le code',
      labelDisabled = 'Renvoyer le code',
    } = this.props;
    const { secondsLeft } = this.state;
    const isDisabled = secondsLeft > 0;

    return (
      <div style={{ display: 'inline-flex', alignItems: 'center', gap: 12 }}>

        <span onClick={this.handleClick} disabled={isDisabled} aria-disabled={isDisabled} style={{ cursor: isDisabled ? 'not-allowed' : 'pointer', textDecoration: "underline" }}> {isDisabled ? labelDisabled : labelReady}</span>



        {isDisabled && (
          <span aria-live="polite" style={{ fontFamily: 'monospace', color: '#555' }}>
            Disponible dans {this.format(secondsLeft)}
          </span>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ResendOTP/ResendOTPPage.js